<section id="intro_section">
  <header>
    <h3 class="paragraph">
      This tool converts plain text into nictographic writing.
    </h3>
  </header>
  <div>
    <p class="paragraph">
      <a
        href="https://en.wikipedia.org/wiki/Nyctography"
        target="_blank"
        rel="noopener"
        class="link"
      >
        Nyctography
      </a>
      is a form of substitution cipher writing created by Lewis Carroll. It is written
      using gridded card with square holes. 
    </p>
    <p class="paragraph">
      This tool uses an
      <a
        href="https://www.dafont.com/nyctographic.font"
        target="_blank"
        rel="noopener"
        class="link"
      >
        extended version
      </a>
      that represents numbers and punctuation as its own character.
    </p>
  </div>
</section>

<style>
  #intro_section {
    margin: 5vh 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: space-evenly;
  }

  header {
    display: grid;
    place-content: center;
  }

  h3.paragraph {
    font-size: xx-large;
    text-align: center;
    color: #c4b1b1; 
  }

  p.paragraph {
    font-size: x-large;
    color: #c4b1b1; 
  }

  .link {
    color: #c4b1b1; 
  }
</style>
